import { EmptyState } from '@/components/common/empty-state';
import { PageHeader } from '@/components/common/page-header';
import type { NavItem } from '@/components/layout/navigation';

export function ComingSoonPage({ item }: { item: NavItem }) {
  return (
    <>
      <PageHeader title={item.label} />
      <EmptyState
        icon={item.icon}
        title="Coming soon"
        description={item.comingSoon ?? 'This feature is on its way.'}
      />
    </>
  );
}
